import React from 'react';
import AxiosConfig from '../../../utilities/AxiosConfig';
import axios from 'axios';
import Loader from '../../common/Loader';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import ReactTooltip from 'react-tooltip';
import CustomSearch from '../../table/CustomSearch';
import { qsStringify } from '../../../utilities/helper';
import InfoButton from '../../common/InfoButton';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Spinner from 'react-bootstrap/Spinner';
import ClipboardIcon from '../../common/ClipboardIcon';
import logger from '../../../utilities/logging';
import './loginSessions.css';
import './portal-session-table.css';
import '../../../styles/rb-table-overwrite.css';


let oldRowCount = 0;
let oldUserCount = 0;
dayjs.extend(utc);

class PortalSessionsTable extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            isMobile: false,
            portalSessions : [],
            loading : true,
            refreshing : false,
            errorMessage : "",
            selectedRows : [],
            radioValue : "enableSelect",
            togglingRows : false,
            numRenderedRows : 0,
            includeExpired : false,
            // numUniqueUsers : 0,
            timeFormat : "local",
            mobileOptionsOpen : false,
            uniqueUsers: [],
            countInterval: null // intervalID, used to clear interval on page unmount
        }
    }

    tableColumns = [
        {
            dataField : "userName",
            text : "User Name",
            // footer: columnData => columnData.reduce((acc, item) => acc + item, 0),
            sort : true,
            // classes: 'session-table-username',
            formatter : (cell, row, rowIndex) => {
                return (
                <div className="w-100 d-flex justify-content-between align-items-center">
                    <p className="session-table-username">{row.userName}</p>
                    <ClipboardIcon title="Copy Session Key" className="p" text={row.sessionKey} />
                </div>
                )
            }
        },
        {
            dataField : "issuedUtc",
            text : "Issued",
            sort : true,
            formatter : (cell, row, rowIndex) => {
                let date = row.issuedUtc;
                return this.state.timeFormat === "local" ? dayjs.utc(date).local().format('M/D/YY h:mm A') : dayjs.utc(date).format('M/D/YY h:mm A');
            },
            sortFunc: (a, b, order, dataField, rowA, rowB) => dayjs(order === "asc" ? rowB.issuedUtc : rowA.issuedUtc).unix() - dayjs(order === "asc" ? rowA.issuedUtc : rowB.issuedUtc).unix()
        },
        {
            dataField : "expiresUtc",
            text : "Expires",
            sort : true,
            formatter : (cell, row, rowIndex) => {
                let date = row.expiresUtc;
                return this.state.timeFormat === "local" ? dayjs.utc(date).local().format('M/D/YY h:mm A') : dayjs.utc(date).format('M/D/YY h:mm A');
            }
        },
        {
            dataField : "lastAccessUtc",
            text : "Last Activity",
            sort : true,
            formatter : (cell, row, rowIndex) => {
                let date = row.lastAccessUtc;
                return this.state.timeFormat === "local" ? dayjs.utc(date).local().format('M/D/YY h:mm A') : dayjs.utc(date).format('M/D/YY h:mm A');
            }
        },
        {
            dataField : "ipAddress",
            text : "IP Address",
            sort : true
        },
        {
            dataField : "clientId",
            text : "Client Id",
            sort : true
        },
        {
            dataField : "isExpired",
            text : "Expired",
            formatter : (cell, row, rowIndex) => {
                return row.isExpired ? "Y" : "N";
            },
            headerStyle: () => {
                return {
                    width : "80px"
                }
            },    
        },
        {
            dataField : "isDisabled",
            text : "Disabled",
            formatter : (cell, row, rowIndex) => {
                if(!row.isDisabled){
                    return "N";
                }
                return (
                    <div data-tip data-for={`tooltip-${row.key}`}>
                        <span className="text-info" >Y</span>
                        <ReactTooltip id={`tooltip-${row.key}`} place="bottom" type="dark">
                            Disabled {row.disabledDate} by {row.disabledBy}.
                        </ReactTooltip>
                    </div>
                )
            },
            headerStyle: () => {
                return {
                    width : "80px"
                }
            },
        }
    ];

    mobileColumns = [
        {
            dataField : "userName",
            text : "User Name",
            sort : true,
            formatter : (cell, row, rowIndex) => {
                return (
                <div className="w-100 d-flex justify-content-between align-items-center">
                    <p className="session-table-username">{row.userName}</p>
                    <ClipboardIcon title="Copy Session Key" className="p" text={row.sessionKey} />
                </div>
                )
            },
            headerStyle: () => {
                return {
                    width : "180px"
                }
            },   
        },
        {
            dataField : "clientId",
            text : "Client Id",
            sort : true,
            headerStyle: () => {
                return {
                    width : "130px"
                }
            },   
        },
        {
            dataField : "ipAddress",
            text : "IP Address",
            sort : true,
            headerStyle: () => {
                return {
                    width : "150px"
                }
            },   
        },
        {
            dataField : "issuedUtc",
            text : "Issued",
            sort : true,
            formatter : (cell, row, rowIndex) => {
                let date = row.issuedUtc;
                return this.state.timeFormat === "local" ? dayjs.utc(date).local().format('M/D/YY h:mm A') : dayjs.utc(date).format('M/D/YY h:mm A');
            },
            headerStyle: () => {
                return {
                    width : "130px"
                }
            },  
        },
        
    ];

    componentDidMount(){
        this.setState({ isMobile : window.innerWidth < 992 })
        this.getPortalSessions();
        this.handleCountsUpdate();
    }

    componentWillUnmount() {
        clearInterval(this.countInterval);
    }

    handleCountsUpdate = () => {
        // 05.05.2023 IJD | This interval was not being cleaned up after leaving the page which was causing a memory leak.
        // Saving it to state allows for clearing the interval on page unmount.
        this.countInterval = setInterval(() => {
            let uniqueUsers = [];
            let rowCount = 0;
            let elements = document.getElementsByClassName("session-table-username");

            // 05.05.2023 IJD | elements from 'getElementsByClassName' are of type 'HTMLCollection' which doesn't allow for the use of forEach so there was an error being thrown.
            // This turns the array-like object into an array so that forEach will work correctly.
            elements = Array.prototype.slice.call(elements);

            elements.forEach(element => {
                rowCount += 1;
                if(!uniqueUsers.includes(element.innerText)){
                    uniqueUsers.push(element.innerText);
                }
            });
            this.setState({ uniqueUsers });
            if(oldRowCount !== rowCount || oldUserCount !== uniqueUsers.length){
                oldRowCount = rowCount;
                oldUserCount = uniqueUsers.length;
                this.setState({ numRenderedRows : rowCount });
            }
        }, 200)
    }

    getPortalSessions = (clearSelected = false, getExpired = false) => {
        if(getExpired){
            this.setState({ refreshing : true });
        }
        let url = process.env.REACT_APP_API_URL + "/api/ops/sessions";
        let config = {...AxiosConfig.configValue()};
        if(getExpired){
            config.params = {
                exp : true
            };
        }
        axios.get(url, config)
        .then(response => {
            //console.log(response, response.data);
            if(response.data.length > 500){
                response.data = response.data.slice(0, 500);
            }
            this.setState({ portalSessions : response.data });
            if(this.state.numRenderedRows === 0){
                this.setState({ numRenderedRows : response.data.length });
            }
        })
        .catch(error => {
            //console.log(error, error.response);
            this.setState({ errorMessage : "There was an error getting portal sessions" });
            logger.Error({
                EventMessage : `PortalSessionsTable -> getPortalSessions -> Error : ${JSON.stringify(error)}`,
                EventCategory : "httprequest"
            })
            AxiosConfig.handleError(error);
        })
        .finally(() => {
            this.setState({ loading : false, refreshing : false, togglingRows : false, selectedRows : clearSelected ? [] : this.state.selectedRows });
        })
    }

    toggleSessionActive = () => {
        const selectedRows = [...this.state.selectedRows];
        let shouldDisable = this.state.radioValue === "disableSelect";
        this.setState({ togglingRows : true });
        let date = new Date().toISOString();
        //console.log("date", date)
        let url = process.env.REACT_APP_API_URL + "/api/ops/sessionstatus";
        let configValue = AxiosConfig.configValue();
        //console.log("Selected Rows", selectedRows);
        if(selectedRows.length === 1){
            const requestBody = {
                key : selectedRows[0],
                disabledDate : shouldDisable ? date : null,
            };
            axios.post(url, qsStringify(requestBody), configValue)
            .then(response => {
                //console.log(response, response.data);
                this.getPortalSessions(true, this.state.includeExpired);
            })
            .catch(error => {
                //console.log(error, error.response, error.response.data);
                alert(`Error enabling/disabling session`);
                logger.Error({
                    EventMessage : `PortalSessionsTable --> toggleSessionActive: length = 1 --> Error : ${JSON.stringify(error)}`,
                    EventCategory : "httprequest",
                });
                AxiosConfig.handleError(error);
            })
        }
        else if(selectedRows.length > 1){
            let itemsProcessed = 0;
            selectedRows.forEach(row => {
                const requestBody = {
                    key : row,
                    disabledDate : shouldDisable ? date : null,
                };
                axios.post(url, qsStringify(requestBody), configValue)
                .then(response => {
                    //console.log(response, response.data);
                    itemsProcessed += 1;
                    if(itemsProcessed === selectedRows.length){
                        //console.log(itemsProcessed)
                        this.getPortalSessions(true, this.state.includeExpired);
                    }
                })
                .catch(error => {
                    //console.log(error, error.response, error.response.data);
                    alert(`Error enabling/disabling session`);
                    logger.Error({
                        EventMessage : `PortalSessionsTable -> GetPortalSessions -> Error : ${JSON.stringify(error)}`,
                        EventCategory : "httprequest"
                    });
                    AxiosConfig.handleError(error);
                })
            })
            this.setState({ togglingRows : false });
        }else{
            alert("Nothing Selected.");
        }
    }

    refreshTable = e => {
        e.preventDefault();
        this.setState({ refreshing : true });
        this.getPortalSessions(false, this.state.includeExpired);
    }

    handleOnSelect = (row, isSelected) => {
        if(!this.state.togglingRows){
            if (isSelected) {
                this.setState(() => ({
                    selectedRows: [...this.state.selectedRows, row.key]
                }));
            }else {
                this.setState(() => ({
                    selectedRows: this.state.selectedRows.filter(item => item !== row.key)
                }));
            }
        }else{
            alert("Please wait until all fields have been updated");
        }
    }

    handleOnSelectAll = (isSelect, rows) => {
        const keys = rows.map(row => row.key);
        if(!this.state.togglingRows){
            if(isSelect){
                this.setState({ selectedRows : keys });
            }else{
                this.setState({ selectedRows : [] });
            }
        }
    }

    toggleRadio = (e) => {
        // //console.log(e.target.value);
        this.setState({ radioValue : e.target.value });
    }

    toggleTimeFormat = e => {
        this.setState({ timeFormat : e.target.value });
        this.refreshTable(e);
    }

    handleExpiredToggle = e => {
        e.preventDefault();
        let final = !this.state.includeExpired
        this.setState({ includeExpired : final });
        if(final){
            //console.log("Calling function");
            this.getPortalSessions(true, true);
        }else{
            //console.log("Calling normal");
            this.getPortalSessions(true);
        }
    }

    handleMobileOptionsToggle = e => {
        this.setState({ mobileOptionsOpen : !this.state.mobileOptionsOpen });
    }

    render() { 
        const { 
            loading, 
            refreshing, 
            portalSessions, 
            radioValue, 
            togglingRows, 
            selectedRows, 
            numRenderedRows,
            includeExpired,
            timeFormat
        } = this.state;

        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,    
            selected : selectedRows,
            onSelect: this.handleOnSelect,
            onSelectAll: this.handleOnSelectAll,
            bgColor: '#C4C5C6'
        };

        const { isMobile } = this.state;

        return (
            <ToolkitProvider
                keyField="key"
                bootstrap4
                data={portalSessions}
                columns={isMobile ? this.mobileColumns : this.tableColumns}
                search
            >
                {
                    props => (
                        <div className="w-100">
                            <div className="d-flex flex-column flex-md-row align-items-center">
                                <div className="d-none d-md-flex flex-row align-items-center">
                                    <InfoButton place="right" id="session-info">
                                        <p>
                                            Active Sessions shown by default. Includes Disabled. Check "Include Expired" to
                                            include expired(inactive) sessions.
                                        </p>
                                    </InfoButton>
                                    <p data-tip data-for="unique-users-tt" className="my-0 ml-3">Showing: {numRenderedRows} Sessions / <span>{this.state.uniqueUsers?.length} Users</span></p>
                                </div>
                                <p data-tip data-for="unique-users-tt" className="mt-1 d-block d-md-none">Showing:{numRenderedRows} Sessions / <span>{this.state.uniqueUsers?.length} Users</span></p>
                                {
                                    this.state.uniqueUsers.length > 0 ?
                                    <ReactTooltip place="bottom" id="unique-users-tt">
                                        <h6>Unique Users</h6>
                                        <ul>
                                        {this.state.uniqueUsers.map(user => <li key={user}>{user}</li>)}
                                        </ul>
                                    </ReactTooltip>
                                    :null
                                }
                            </div>
                        {
                            loading
                            ?
                            <div style={{height : "350px"}} className="w-100 d-flex flex-row justify-content-center align-items-center">
                                <Loader title="Loading Sessions..." />
                            </div>
                            :
                            <>
                            <div className="d-flex flex-row justify-content-between pb-2 align-items-center align-items-md-end flex-column flex-md-row">
                                <div className="d-flex d-md-none flex-row" style={{ maxHeight : "40px" }}>
                                    <CustomSearch className="toolbar-item" callback={ this.handleCountsUpdate } placeholder="Filter" {...props.searchProps} />
                                    <Button disabled={refreshing} size="sm" onClick={this.refreshTable}>
                                        <i className="material-icons">refresh</i>
                                    </Button> 
                                    <Button varian="outline-secondary" onClick={this.handleMobileOptionsToggle}>{this.state.mobileOptionsOpen ? "Close" : "Open"}</Button>
                                </div>
                                {
                                    this.state.mobileOptionsOpen && isMobile &&(
                                    <>
                                    <Form className="d-flex flex-row justify-content-center align-items-center my-2">
                                        <Form.Check 
                                            checked={radioValue === "disableSelect"} 
                                            type="radio" 
                                            title="Disable Selected Sessions" 
                                            label="Disable" 
                                            name="toggles"
                                            onChange={this.toggleRadio}
                                            value="disableSelect"
                                            disabled={loading || refreshing}
                                        />
                                        <Form.Check 
                                            checked={radioValue === "enableSelect"} 
                                            type="radio" 
                                            title="Enable Selected Sessions" 
                                            label={isMobile ? "Enable" : "Enable Selected Sessions"}
                                            name="toggles"
                                            onChange={this.toggleRadio}
                                            value="enableSelect"
                                            disabled={loading || refreshing}
                                            className="mx-3"
                                        />
                                        <Button 
                                            disabled={togglingRows || selectedRows.length === 0 || loading || refreshing} 
                                            onClick={this.toggleSessionActive} 
                                            variant="outline-secondary" 
                                            title="Apply Changes"
                                        >
                                            {togglingRows ? <Spinner size="sm" role="status" as="span" animation="border"/> : "Apply"}
                                        </Button>
                                    </Form>
                                    <div className="d-flex flex-row">
                                        <Button 
                                            disabled={loading || refreshing} 
                                            value={timeFormat === "local" ? "utc" : "local"} 
                                            onClick={this.toggleTimeFormat}
                                            variant="outline-secondary"
                                        >
                                            Time Format: {timeFormat}
                                        </Button>
                                        <Button 
                                            disabled={loading || refreshing} 
                                            onClick={this.handleExpiredToggle}
                                        >
                                            {includeExpired ? "Including Expired" : "Excluding Expired"}
                                        </Button>
                                    </div>
                                    </>
                                    )
                                }
                                {
                                    !isMobile&&
                                    <>
                                    <Form className="d-flex flex-row justify-content-center align-items-center">
                                    <Form.Check 
                                        checked={radioValue === "disableSelect"} 
                                        type="radio" 
                                        title="Disable Selected Sessions" 
                                        label="Disable" 
                                        name="toggles"
                                        onChange={this.toggleRadio}
                                        value="disableSelect"
                                        disabled={loading || refreshing}
                                    />
                                    <Form.Check 
                                        checked={radioValue === "enableSelect"} 
                                        type="radio" 
                                        title="Enable Selected Sessions" 
                                        label="Enable Selected Sessions"
                                        name="toggles"
                                        onChange={this.toggleRadio}
                                        value="enableSelect"
                                        disabled={loading || refreshing}
                                        className="mx-3"
                                    />
                                    <Button 
                                        size="sm" 
                                        disabled={togglingRows || selectedRows.length === 0 || loading || refreshing} 
                                        onClick={this.toggleSessionActive} 
                                        variant="outline-secondary" 
                                        title="Apply Changes"
                                    >
                                        {togglingRows ? <Spinner size="sm" role="status" as="span" animation="border"/> : "Apply"}
                                    </Button>
                                </Form>
                                <Form.Check 
                                    label="Include Expired (Last 90 days)"
                                    checked={includeExpired}
                                    onChange={this.handleExpiredToggle}
                                    type="checkbox"
                                    disabled={loading || refreshing}
                                />
                                <div className="d-flex flex-row">
                                    <h6>Times In: </h6>
                                    <Form.Check 
                                        checked={timeFormat === "local"} 
                                        type="radio" 
                                        title="Local Time" 
                                        label="Local Time" 
                                        className="mx-2"
                                        value="local"
                                        onChange={ this.toggleTimeFormat }
                                    />
                                    <Form.Check 
                                        checked={timeFormat === "utc"} 
                                        type="radio" 
                                        title="UTC Time" 
                                        label="UTC Time"
                                        value="utc" 
                                        onChange={ this.toggleTimeFormat }
                                    />
                                </div>
                                </>
                                }
                                <div className="d-none d-md-flex">
                                    <CustomSearch className="toolbar-item w-100" callback={ this.handleCountsUpdate } placeholder="Filter" {...props.searchProps} />
                                    <Button disabled={refreshing} size="sm" onClick={this.refreshTable}>
                                        <i className="material-icons">refresh</i>
                                    </Button> 
                                </div>
                            </div>
                            <div style={{height : "calc(66vh - 48px)", overflowY : "scroll"}}>
                                {
                                    refreshing
                                    ?
                                    <div style={{height : "350px"}} className="w-100 d-flex flex-row justify-content-center align-items-center">
                                        <Loader title="Refreshing Table..." />
                                    </div>
                                    :
                                    <BootstrapTable 
                                        {...props.baseProps}
                                        hover={true}
                                        condensed={true}
                                        selectRow={selectRow}
                                        noDataIndication={() => <h5>No Sessions Found.</h5>}
                                        // onDataSizeChange={ this.handleDataChange }
                                        wrapperClasses="PortalSessionTable"
                                        // pagination={ this.state.numRenderedRows > 100 && paginationFactory()}
                                    />
                                }
                            </div>
                            </>
                        }
                        </div>
                    )
                }
            </ToolkitProvider>
        );
    }
}

export default PortalSessionsTable;